import React, { useEffect, useState } from 'react'
// React Router
import { useNavigate } from 'react-router-dom'
// Ant Design
import { Flex, Typography, DatePicker, Empty, Button, Popconfirm, message, Spin, Select } from 'antd'
// Ant Design Icons
import { DeleteOutlined } from '@ant-design/icons'
// Layouts
import { Linea } from '../../Layout/GraphsData/Linea'
import { Pastel } from '../../Layout/GraphsData/Pastel'
import { Barras } from '../../Layout/GraphsData/Barras'
import { Dona } from '../../Layout/GraphsData/Dona'
import { Range } from '../../Layout/GraphsData/Range'
import { Card } from '../../Layout/GraphsData/Card'
// Axios
import axios from 'axios'
// Config
import config from '../../config'
import { getConfig } from '../../config'

const { Title } = Typography

export const ContentViews = ({ t, selectView, isGraph, setIsGraph, apiViews, error404, setError404 }) => {

    const { RangePicker } = DatePicker;
    const [dates, setDates] = useState([null, null]);
    const [messageApi, contextHolder] = message.useMessage();
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()

    useEffect(() => {
        if(!isGraph) {
            setDates([null, null])
        }
    }, [isGraph])

    const getYearMonth = (date) => date.getFullYear() * 12 + date.getMonth();
    const disabled7DaysDate = (current, { from, type }) => {
        if (from) {
            const minDate = new Date(from);
            const maxDate = new Date(minDate);
            maxDate.setDate(minDate.getDate() + 6);

            const today = new Date();
            today.setHours(0, 0, 0, 0);

            if (current > today) {
                return true;
            }

            switch (type) {
                case 'year':
                    return current.getFullYear() < minDate.getFullYear() || current.getFullYear() > maxDate.getFullYear();
                case 'month':
                    return getYearMonth(current) < getYearMonth(minDate) || getYearMonth(current) > getYearMonth(maxDate);
                default:
                    return current < minDate || current > maxDate;
            }
        }
        return false;
    };

    const onDelete = async() => {
        try {
            const res = await axios.delete(`${config.urlApi}/private/views/${selectView._id}`, {
                withCredentials: true,
            })
            if(res.status === 200) {
                messageApi.success(t("success_delete_view"))
                apiViews()
            }
        }
        catch (error) {
            if (error.status === 401) {
                navigate("/")
            }
            else if (error.status === 404) {
                messageApi.error(t("error_delete_view_not_found"))
            }
            else {
                messageApi.error(t("error_delete_view"))
            }
        }
    }

    const changeDate = async (dates, dateStrings, values) => {
        if (dateStrings) {
            setIsGraph(false)
            setLoading(true)
            const startDate = dateStrings[0].split("-").reverse().join("/");
            const endDate = dateStrings[1].split("-").reverse().join("/");
            const idReports = selectView.reports.map(report => report._id)

            try {
                const res = await axios.post(config.urlApi + "/private/views/stats", {
                    reports_id: idReports,
                    start_date: startDate,
                    end_date: endDate,
                });
                if (res.status === 200) {
                    const arrNew = []
                    res.data.data.forEach(graph => {
                        if (graph.searchFilters.logicOperator === "OPTION" || graph.searchFilters.logicOperator === "OR") {
                            arrNew.push({
                                ...graph,
                                channel: graph.searchFilters.values[0].value,
                            })
                        }
                        else {
                            arrNew.push(graph)
                        }
                    })
                    setData(arrNew)

                    setDates(values)
                    setIsGraph(true)
                    setLoading(false)
                }
            }
            catch (error) {
                setLoading(false)
                if (error.status === 401) {
                    navigate("/")
                }
                else if (error.status === 404) {
                    setError404(true)
                }
                else {
                    messageApi.error(t("error_filter_date"))
                }
            }
        }
    }

    const selectChannel = (value, graph) => {
        const newData = data.map(item => {
            if (item.report_id === graph.report_id) {
                return {
                    ...item,
                    channel: value,
                };
            }
            return item;
        });
        setData(newData);
    };

    return (
        <Flex vertical style={{ position: "relative", width: "75%", height: "calc(100vh - 60px)" }}>
            <Flex justify="space-between" style={{ width: "100%", height: "50px", paddingLeft: "10px" }}>
                <Flex align="center" style={{ width: "50%" }}>
                    <Title level={4} style={{ color: getConfig("colorPrimario"), margin: "0" }}>{selectView.name_view}</Title>
                </Flex>
                <Flex align="center" style={{ width: "50%" }}>
                    <RangePicker onChange={changeDate} value={dates} disabledDate={disabled7DaysDate} style={{ width: "100%" }} placeholder={[t("filter_datestart"), t("filter_dateend")]} />
                </Flex>
            </Flex>

            <Flex style={{ width: "100%", height: "calc(100% - 60px)", padding: "0 10px" }}>
                {!isGraph
                    ?
                    <Flex justify="center" align="center" style={{ width: "100%", height: "100%" }}>
                        {loading 
                            ? <Spin size="large" style={{ color: getConfig("colorPrimario") }} />
                            : <Empty
                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                description={error404 ? t("not_found_range_date") : t("choose_date")}
                            />
                        }
                    </Flex>
                    :
                    <Flex wrap style={{ width: "100%", height: "100%", backgroundColor: "#F5F7FA", borderRadius: "10px", overflowY: "auto" }}>
                        {data.map(graph => (
                            <Flex key={graph.report_name} vertical justify="center" align="center" style={{ width: "50%", height: "350px" }}>
                                {graph.name_report===undefined
                                    ? <Empty
                                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                                        description={t("not_found_range_date")}
                                    />
                                    :
                                    <>
                                        <Title level={4} style={{ color: getConfig("colorSecundario"), marginBottom: "10px", textAlign: "center" }}>{graph.name_report}</Title>
                                        
                                        {(graph.searchFilters.logicOperator==="OPTION" || graph.searchFilters.logicOperator==="OR") &&
                                            <Select
                                                onChange={(value) => selectChannel(value, graph)}
                                                value={graph.channel}
                                                style={{ width: "60%", marginBottom: "10px", backgroundColor: "#F5F7FA" }}
                                                options={graph.searchFilters.values.map(value => ({
                                                    label: value.value,
                                                    value: value.value,
                                                }))}
                                            />
                                        }
                                        
                                        {
                                            graph.graph_type === "lineas" ? <Linea key={graph.report_id + graph.channel} graph={graph} /> :
                                            graph.graph_type === "pastel" ? <Pastel key={graph.report_id + graph.channel} graph={graph} /> :
                                            graph.graph_type === "barras" ? <Barras key={graph.report_id + graph.channel} graph={graph} /> :
                                            graph.graph_type === "dona" ? <Dona key={graph.report_id + graph.channel} graph={graph} /> :
                                            graph.graph_type === "medidor" ? <Range key={graph.report_id + graph.channel} graph={graph} /> :
                                            graph.graph_type === "card" ? <Card key={graph.report_id + graph.channel} graph={graph} size={"sm"} /> : null
                                        }
                                    </>
                                }
                            </Flex>
                        ))}
                    </Flex>
                }
            </Flex>

            {!selectView.created_by_admin &&
                <Popconfirm
                    title={t("sure_delete_view")}
                    description={t("sure_delete")}
                    onConfirm={onDelete}
                    okText={t("txt_yes")}
                    cancelText="No"
                    placement="topLeft"
                    zIndex={999999}
                >
                    <Button ghost size="large" shape="circle" icon={<DeleteOutlined />} style={{ position: "absolute", bottom: "10px", right: "0", color: "red", border: "1.5px solid red" }} />
                </Popconfirm>
            }

            {contextHolder}
        </Flex>
    )
}
